/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import './links-downloads.scss';
import './modifier/documents.scss';
import './modifier/cms.scss';
import './modifier/autosplit.scss';
